import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './App.css';
import Header from './componet/Header';
import Profile from './componet/Profile';
import Content from './componet/Content';
import Footer from './componet/Footer';

function App() {
  const location = useLocation();
  const navigate = useNavigate();

  // URL 쿼리 매개변수에서 언어 상태를 가져옵니다.
  const query = new URLSearchParams(location.search);
  const initialLanguage = query.get('lang') || 'en'; 

  const [language, setLanguage] = useState(initialLanguage);

  const handleLanguageChange = (lang) => {
    setLanguage(lang);
    // URL 쿼리 매개변수를 업데이트합니다.
    query.set('lang', lang);
    navigate({ search: query.toString() });
  };

  useEffect(() => {
    setLanguage(initialLanguage);
  }, [initialLanguage]);


  return (
    <div className="container">
      <Header onLanguageChange={handleLanguageChange} language={language} />
      <Profile language={language}/>
      <Content language={language} />
      <Footer />
    </div>
  );
}

export default App;
